export default "__VITE_PUBLIC_ASSET__8781152a__"